import React from 'react';
import {
  comparionTableRowClassName,
  comparionTableCellClassName,
  comparionTableFirstColClassName,
} from './Styles';

interface ComparisonRowProps {
  label: string;
  values: (string | number)[];
  isWhiteBackground?: boolean;
}

export default function ComparisonRow({ label, values, isWhiteBackground = false }: ComparisonRowProps) {
  const rowClassName = isWhiteBackground 
    ? `${comparionTableRowClassName} !bg-white` 
    : comparionTableRowClassName;

  return (
    <div className={rowClassName}>
      <div className={comparionTableFirstColClassName}>{label}</div>
      {values.map((value, index) => (
        <div key={index} className={comparionTableCellClassName}>
          {value}
        </div>
      ))}
    </div>
  );
}